/* unplugin-vue-components disabled */import script from "./SpinLog.vue?vue&type=script&setup=true&lang=js"
export * from "./SpinLog.vue?vue&type=script&setup=true&lang=js"

import "./SpinLog.vue?vue&type=style&index=0&id=4aed666e&lang=less"

const __exports__ = script;

export default __exports__